import React from "react";
import { Box, Button } from "@mui/material";
import { Icon, iconClose } from "theme/icons";
import { alignCenter } from "theme/styles";
import Video from "./Components/Video";

type Props = {
  triggerGetStartedModal: Function;
};

export const GetStartedModal = React.forwardRef(({ triggerGetStartedModal }: Props, ref) => {
  return (
    <Box height={"100%"} width={"100%"} ref={ref}>
      <Button
        style={{ position: "absolute", right: "10px", top: "10px" }}
        onClick={() => triggerGetStartedModal(false)}
      >
        <Icon name={iconClose} htmlColor={"white"} size={"xlarge"} />
      </Button>
      <Box sx={alignCenter} height={"100%"} width={"100%"}>
        <Video id="getStarted" height="75%" />
      </Box>
    </Box>
  );
});
